var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "calendar"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector ",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.00001 0.625C4.20711 0.625 4.37501 0.792893 4.37501 1V1.62498H7.62499V1C7.62499 0.792893 7.79289 0.625 7.99999 0.625C8.2071 0.625 8.37499 0.792893 8.37499 1V1.62498H9.5C10.2594 1.62498 10.875 2.24059 10.875 2.99998V9.99998C10.875 10.7594 10.2594 11.375 9.5 11.375H2.5C1.74061 11.375 1.125 10.7594 1.125 9.99998V2.99998C1.125 2.24059 1.74061 1.62498 2.5 1.62498H3.62501V1C3.62501 0.792893 3.7929 0.625 4.00001 0.625ZM3.62501 2.37498H2.5C2.15482 2.37498 1.875 2.65481 1.875 2.99998V4.62498H10.125V2.99998C10.125 2.65481 9.84518 2.37498 9.5 2.37498H8.37499V3C8.37499 3.20711 8.2071 3.375 7.99999 3.375C7.79289 3.375 7.62499 3.20711 7.62499 3V2.37498H4.37501V3C4.37501 3.20711 4.20711 3.375 4.00001 3.375C3.7929 3.375 3.62501 3.20711 3.62501 3V2.37498ZM10.125 5.37498H1.875V9.99998C1.875 10.3452 2.15482 10.625 2.5 10.625H9.5C9.84518 10.625 10.125 10.3452 10.125 9.99998V5.37498Z",
  fill: "#00538F"
}));

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.0607d40e.svg";
export { ForwardRef as ReactComponent };